import { Injectable } from '@angular/core';
import { ofType, Actions, Effect } from '@ngrx/effects';
import { mergeMap, map , withLatestFrom  } from 'rxjs/operators';
import { CustomerSupportActionTypes, SetHotlineNumber, StoreHotlineNumber, CustomerSupportContractCancellation , CustomerSupportReviewItems} from '../actions/customer-support.actions';
import { CustomerSupportSerivce } from 'src/app/shared/services/customer-support.service';
import { of } from 'rxjs';
import { CustomerTypes } from 'src/app/models/delivery.model';
import { RoutingAction } from '../actions/routing.action';
import { config } from '../../../config/pages-config';
import { Store, select } from '@ngrx/store';
import { AppState } from '../reducers';
import { getPositionSelected } from '../selectors/order-details.selectors';
import { OrderDetailedService } from 'src/app/shared/services/order-details.service';

/** CustomerSupportEffect */
@Injectable()
export class CustomerSupportEffect {

    /** url */
    public url;
     /** the current user customer's type */
     public customerType: CustomerTypes;
 /** the current Returned Entitled  */
     public currentReturnedEntitled;

   /** setHotLineNumber */
    @Effect()
    public setHotLineNumber = this.actions.pipe(ofType<SetHotlineNumber>(CustomerSupportActionTypes.SET_HOTLINE_NUMBER), mergeMap(
        ac => {
            return this.customerSupportSerivce.getHotLineNumber(ac.payload.cmsPath, ac.payload.salesChannel).pipe(mergeMap((hotlineNumber) => {

                 return of(new StoreHotlineNumber({hotlineNumber: hotlineNumber}));
             }));

        },
    ));
/** customerSupportContractCancellation */
    @Effect()
    public customerSupportContractCancellation$ = this.actions.pipe(
        ofType<CustomerSupportContractCancellation>(CustomerSupportActionTypes.CUSTOMER_SUPPORT_CONTRACT_CANCELLATION),
        map(action => {
            this.customerType = action.payload.customerType;
        }),
        withLatestFrom(this.store.pipe(select(getPositionSelected))),
        map(() => {

            switch (this.customerType) {

                case CustomerTypes.Lion:
                case CustomerTypes.Leopard:
                case CustomerTypes.NeoLion:
                case CustomerTypes.NeoLeopard:
                case CustomerTypes.Polarbear:
                    this.url = config.review.revocationSelectionReview.route;
                    break;
                case CustomerTypes.Tiger:
                    this.url = config.winback.WinbackPage.route;
                    break;
                case CustomerTypes.Python:
                    this.url = config.confirmation.simOnlyRevocationConfirmation.route;
                    break;
                case CustomerTypes.NeoTiger:
                    this.url = config.winback.WinbackPage.route;
                    break;
            }

           return new RoutingAction({
                url: this.url,
            });
        }));

        /** customerSupportReviewItems */

    @Effect()
    public customerSupportReviewItems$ = this.actions.pipe(
        ofType<CustomerSupportReviewItems>(CustomerSupportActionTypes.CUSTOMER_SUPPORT_REVIEW_ITEMS),
        map(action => {
            this.customerType = action.payload.customerType;
        }),
        map(() => {
            switch (this.customerType) {

                case CustomerTypes.Snowlion:
                case CustomerTypes.Snowleopard:
                case CustomerTypes.SnowNeoLion:
                case CustomerTypes.SnowNeoLeopard:
                case CustomerTypes.SnowPolarbear:

                      this.url = config.revocation.revocationSelection.route;
                break;
        }

           return new RoutingAction({
                url: this.url,
            });
        }));
        /**
         *
         * @param actions
         * @param customerSupportSerivce
         * @param orderDetailedService
         * @param store
         */
        public constructor (public actions: Actions, private customerSupportSerivce: CustomerSupportSerivce,  private orderDetailedService: OrderDetailedService, private store: Store<AppState>) { }
    }
